'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dofSlider = require('../dof-slider');

var _dofSlider2 = _interopRequireDefault(_dofSlider);

var _dofMarquee = require('../dof-marquee');

var _dofMarquee2 = _interopRequireDefault(_dofMarquee);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _style = require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var dom = weex.requireModule('dom');
exports.default = {
  mixins: [_colmo2.default],
  components: {
    DofSlider: _dofSlider2.default,
    DofMarquee: _dofMarquee2.default,
    DofIconfont: _dofIconfont2.default
  },
  props: {
    volume: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    play: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'brand'
    },
    trackHeight: {
      type: Number,
      default: undefined
    },
    trackColor: {
      type: String,
      default: '#F2F2F2'
    },
    barColor: {
      type: String,
      default: ''
    },
    buttonSize: {
      type: Number,
      default: undefined
    },
    buttonColor: {
      type: String,
      default: '#ffffff'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    }
  },

  data: function data() {
    return {
      moveImg: 'http://dolphin-weex-dev.msmartlife.cn/cdn/images/common/music-wave.png',
      playImg: 'http://dolphin-weex-dev.msmartlife.cn/cdn/images/common/play.png',
      pauseImg: 'http://dolphin-weex-dev.msmartlife.cn/cdn/images/common/pause.png',
      nextImg: 'http://dolphin-weex-dev.msmartlife.cn/cdn/images/common/next.png',
      volumeLowImg: 'http://dolphin-weex-dev.msmartlife.cn/cdn/images/common/volume-low.png',
      volumeHighImg: 'http://dolphin-weex-dev.msmartlife.cn/cdn/images/common/volume-high.png',
      topTitleWidth: 0,
      titleLenWidth: 0,
      marqueeWidth: '0px',
      marqueeTextWidth: '0px'
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var ele1 = _this.$refs.topTitle;
      var ele2 = _this.$refs.titleLen;
      _this.getEleWidth(ele1, 'topTitle');
      _this.getEleWidth(ele2, 'titleLen');
    });
  },

  computed: {
    themeStyle: function themeStyle() {
      var _theme = this._theme || 'default';
      console.log('_theme');
      console.log(_style.STYLE_MAP[_theme].marqueeTextColor);

      return _style.STYLE_MAP[_theme] || _style.STYLE_MAP['default'];
    },
    _buttonSize: function _buttonSize() {
      var tmp = this.buttonSize || this.themeStyle.buttonSize;
      return tmp;
    },
    _trackHeight: function _trackHeight() {
      var tmp = this.trackHeight || this.themeStyle.trackHeight;
      return tmp;
    },
    _gradientBarConfig: function _gradientBarConfig() {
      return this._theme == 'colmo' ? { start: 'rgba(255,255,255,0)', end: '#fff' } : {};
    },
    playText: function playText() {
      return this.play ? '播放中' : '已暂停';
    },
    marqueeText: function marqueeText() {
      return this.playText + ': ' + this.title;
    },
    marqueeShowFlag: function marqueeShowFlag() {
      return this.titleLenWidth > this.topTitleWidth ? true : false;
    }
  },
  methods: {
    sliderChangeHandler: function sliderChangeHandler(val) {
      this.$emit('dofVolumeChanged', val);
    },
    playHandler: function playHandler(type) {
      this.play = !this.play;
      this.$emit('dofPlayClicked', type);
    },
    nextHandler: function nextHandler() {
      this.$emit('dofNextClicked');
    },
    getEleWidth: function getEleWidth(ele, str) {
      var self = this;
      dom.getComponentRect(ele, function (result) {
        var size = result.size || {};
        var width = parseInt(size.width);
        if (!width) {
          self.getEleWidth(ele, str);
        } else {
          if (str == 'topTitle') {
            self.topTitleWidth = width;
            self.marqueeWidth = width + 'px';
            self.marqueeTextWidth = parseInt(width + 400) + 'px';
          } else if (str == 'titleLen') {
            self.titleLenWidth = width;
          }
        }
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-music-player/index.vue
// module id = 356
// module chunks = 0 1